import React, { Component } from 'react';
import { WidgetHelper } from '../WidgetHelper';
import { ContentOpinionType } from '../../Models';
import { ContentService } from '../../Services';

interface IContentOpinionWidgetProps {
    contentId: number;
    opinionLabel: string;
    opinionVotedLabel: string;
    dictWithEuSupport?: string;
    dictEuSupport?: string;
    isServiceFse: string;
    dictSend: string;
    dictYes: string;
    dictNo: string;
    dictCommentSuccess: string;
    dictCommentFail: string;
    dictCommentInvite: string;
    dictYourComment: string;
    contactUrl: string;
    contactString: string;
}

interface IContentOpinionWidgetState {
    isOpinionSet: boolean;
    opinionValue: ContentOpinionType;
    comment: string;
    commentSentSuccess: boolean;
    commentSent: boolean;
}

export class ContentOpinionWidget extends Component<
    IContentOpinionWidgetProps,
    IContentOpinionWidgetState
> {
    constructor(props: IContentOpinionWidgetProps) {
        super(props);
        this.state = {
            comment: '',
            isOpinionSet: false,
            opinionValue: null as any,
            commentSentSuccess: null as any,
            commentSent: null as any,
        };
    }

    async setOpinion(opinion: ContentOpinionType) {
        try {
            await ContentService.setOpinion(this.props.contentId, opinion);
            this.setState({
                isOpinionSet: true,
                opinionValue: opinion,
            });
        } catch (e) {
            if (!(e instanceof DOMException) || e.name !== 'AbortError') {
                throw e;
            }
        }
    }

    sendComment = async () => {
        try {
            const result = await ContentService.sendComment(
                this.props.contentId,
                this.state.comment,
                window.location.href.replace('#comment', '')
            );

            if (result.ok) {
                this.setState({ commentSentSuccess: true, commentSent: true });
            }
        } catch (error) {
            /* empty */
            console.error(error);
        }
    };

    changeComment = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
        this.setState({ comment: event.target.value });
    };

    render() {
        const fontSize = { fontSize: '150%' } as React.CSSProperties;

        let opinionLabel: JSX.Element;
        if (this.state.isOpinionSet) {
            opinionLabel = (
                <div id="comment">
                    {this.state.opinionValue != ContentOpinionType.Negative && (
                        <span style={fontSize}>
                            {this.props.opinionVotedLabel}{' '}
                            <a href={this.props.contactUrl}>
                                {this.props.contactString}
                            </a>
                        </span>
                    )}
                    {this.state.opinionValue == ContentOpinionType.Negative && (
                        <div>
                            {!this.state.commentSent && (
                                <>
                                    {this.props.dictCommentInvite}
                                    <textarea
                                        placeholder={this.props.dictYourComment}
                                        value={this.state.comment}
                                        onChange={this.changeComment}
                                        maxLength={400}
                                        className="my-4"
                                    />
                                    <div className="text-right">
                                        <a href="#comment">
                                            <button
                                                className="btn-primary mt-1"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    void this.sendComment();
                                                }}
                                            >
                                                {this.props.dictSend}
                                                <i className="icon icon-send ml-3 mr-0"></i>
                                            </button>
                                        </a>
                                    </div>
                                </>
                            )}
                            {this.state.commentSent && (
                                <>
                                    {this.state.commentSentSuccess && (
                                        <>
                                            {this.props.dictCommentSuccess}{' '}
                                            <a href={this.props.contactUrl}>
                                                {this.props.contactString}
                                            </a>
                                        </>
                                    )}
                                    {!this.state.commentSentSuccess && (
                                        <>{this.props.dictCommentFail}</>
                                    )}
                                </>
                            )}
                        </div>
                    )}
                </div>
            );
        } else {
            opinionLabel = (
                <>
                    <span style={fontSize}>{this.props.opinionLabel}</span>
                    <div className="smiley">
                        <a
                            href="#comment"
                            onClick={(e) => {
                                e.preventDefault();
                                void this.setOpinion(
                                    ContentOpinionType.Positive
                                );
                            }}
                        >
                            <i
                                aria-hidden="true"
                                className="icon-smile gtm-opinion"
                                style={fontSize}
                                data-gtmOpinion="Positive"
                            ></i>
                            <span className="sr-only">
                                {this.props.dictYes}
                            </span>
                        </a>
                        <a
                            href="#comment"
                            onClick={(e) => {
                                e.preventDefault();
                                void this.setOpinion(
                                    ContentOpinionType.Negative
                                );
                            }}
                        >
                            <i
                                aria-hidden="true"
                                className="icon-sad gtm-opinion"
                                style={fontSize}
                                data-gtmOpinion="Negative"
                            ></i>
                            <span className="sr-only">{this.props.dictNo}</span>
                        </a>
                    </div>
                </>
            );
        }

        return (
            <div className="review-bloc fse">
                <div>{opinionLabel}</div>
                {this.props.isServiceFse &&
                    this.props.isServiceFse.toUpperCase() == 'TRUE' && (
                        <div>
                            <img
                                className="logo-brand"
                                src="/Assets/eu.jpg"
                                alt="ue"
                            />
                            <div className="logo-label">
                                <span>{this.props.dictWithEuSupport}</span>
                                <span>{this.props.dictEuSupport}</span>
                            </div>
                        </div>
                    )}
            </div>
        );
    }
}

WidgetHelper.register(ContentOpinionWidget, 'content-opinion-widget');
